import instance from "./api";

export default {
  getCurrencies: async () => {
    return instance.get("/currencies");
  },
};
